import React from "react";

const BubbleBackground = ({
  children,
  bgColor = "#2DD4BF",
  isCardCover = false,
}) => {
  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      }  w-full flex items-center justify-center overflow-hidden`}
      style={{ backgroundColor: `${bgColor}33` }} // 20% Opazität für Hintergrund
    >
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <radialGradient
            id="bubble-gradient"
            cx="50%"
            cy="50%"
            r="50%"
            fx="50%"
            fy="50%"
          >
            <stop offset="0%" stopColor={`${bgColor}33`} /> {/* 20% Opazität */}
            <stop offset="100%" stopColor={`${bgColor}00`} />{" "}
            {/* 0% Opazität */}
          </radialGradient>
        </defs>
        <g className="bubbles">
          <circle cx="10%" cy="20%" r="40" fill="url(#bubble-gradient)">
            <animate
              attributeName="cy"
              from="120%"
              to="-20%"
              dur="20s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="30%" cy="80%" r="30" fill="url(#bubble-gradient)">
            <animate
              attributeName="cy"
              from="120%"
              to="-20%"
              dur="15s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="60%" cy="40%" r="50" fill="url(#bubble-gradient)">
            <animate
              attributeName="cy"
              from="120%"
              to="-20%"
              dur="18s"
              repeatCount="indefinite"
            />
          </circle>
          <circle cx="80%" cy="70%" r="35" fill="url(#bubble-gradient)">
            <animate
              attributeName="cy"
              from="120%"
              to="-20%"
              dur="12s"
              repeatCount="indefinite"
            />
          </circle>
        </g>
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default BubbleBackground;
